module.exports = __webpack_public_path__ + "static/media/CancelIcon.c284bb9c.png";